import React from "react";
import { Box, Typography } from "@mui/material";
// import UserListModaledit from "./UserListModaledit";
import VideoListModaledit from "./VideoListModaledit";
import { makeStyles } from "@mui/styles";
import VideoListModaldelete from "./VideoListModaldelete";
import { ChangeDate } from "../../helpers/Date";
import {Button} from "@mui/material";
import { useNavigate } from "react-router-dom";

const VideoListtable = ({ number, item, render, setRender }) => {
  const navigate = useNavigate();
  const classes = useStyles();
  return (
    <>
      <Box
        sx={{
          display: "flex",
          background: "#fff",
          color: "#fff",
          // height: "45px",
          width: "1900px",
        }}
      >
        <Typography
          sx={{
            width: "70px",
            display: "flex",
            color: "#fff",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {number + 1}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item?.name}
        </Typography>
        <Typography
          sx={{
            width: "400px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item?.link}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            // height: 44,
            color: "#000",
            background: "#fff",
            fontSize: "13px",
          }}
        >
          {item?.course?.name}
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item?.chapter?.name}
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item?.user?.name}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          &nbsp;{ChangeDate(item?.createdAt)}
        </Typography>
        {/* <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#004A99",
          }}
        >
          ရက်စွဲ 
        </Typography> */}
        <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
            // height: 44,
            justifyContent: "center",
          }}
        >
          &nbsp;{ChangeDate(item?.updatedAt)}
        </Typography>
        <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            color: "#fff",
            background: "#fff",
            // height: 44,
            justifyContent: "center",
          }}
        >
          <VideoListModaledit
            item={item}
            setRender={setRender}
            render={render}
          />
          <VideoListModaldelete
            item={item}
            setRender={setRender}
            render={render}
          />
        </Typography>
        {/* <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            color: "#fff",
            background: "#fff",
            // height: 44,
            justifyContent: "center",
          }}
        >
          <Button sx={{boxShadow:'none !important'}} variant="contained"
            onClick={() => navigate(`/video/video-detail${item._id}`)}
          >
            detail
          </Button>
        </Typography> */}
      </Box>
    </>
  );
};

const useStyles = makeStyles({
  image: {
    width: "100%",
    marginRight: "25px",
  },
});

export default VideoListtable;
